import React from 'react';
import ExternalLink from 'icons/external-link.svg';
import Logo from 'icons/logo-white.svg';
import styles from './BrandSection.module.css';
const BrandSection = () => {
  return <div className={styles.brandWrapper} data-sentry-component="BrandSection" data-sentry-source-file="BrandSection.tsx">
      <div className={styles.logo}>
        <Logo alt="UR" role="img" aria-label="UR" data-sentry-element="Logo" data-sentry-source-file="BrandSection.tsx" />
      </div>
      <div className={styles.links}>
        <p className={styles.paragraph}>
          <a href="https://www.ur.se/integritetspolicy" target="_blank" rel="noopener" className={styles.link}>
            Integritetspolicy
            <ExternalLink className={styles.externalIcon} role="img" aria-label="Öppnas i nytt fönster" data-sentry-element="ExternalLink" data-sentry-source-file="BrandSection.tsx" />
          </a>
        </p>
        <p className={styles.paragraph}>
          <a href="https://www.ur.se/kontakt" target="_blank" rel="noopener" className={styles.link}>
            Kontakt
            <ExternalLink role="img" aria-label="Öppnas i nytt fönster" className={styles.externalIcon} data-sentry-element="ExternalLink" data-sentry-source-file="BrandSection.tsx" />
          </a>
        </p>
        <p className={styles.paragraph}>
          Ansvarig utgivare: Margaretha Eriksson
        </p>
        <p className={styles.paragraph}>Sveriges Utbildningsradio AB</p>
      </div>
    </div>;
};
export default BrandSection;